<template>
  <div class="component item-list" :class="[type]">
    <ol>
      <li v-for="(item, index) in items" :key="index">
        <router-link :to="{ name: item.routeName, params: {id: item.id} }" v-if="item.type !== 'product'">
          <item-list-summary-default :item="item" />
        </router-link>
        <product-detail :item="item" v-if="item.type === 'product'" :excerptLength="200"/>
      </li>
    </ol>
  </div>
</template>

<script>
import ItemListSummaryDefault from '@/components/ItemListSummaryDefault.vue';
import ProductDetail from '@/components/ProductDetail.vue'

export default {
  props: {
    items: Array,
    type: {
      type: String,
      default: 'grid'
    }
  },

  components: {
    ItemListSummaryDefault,
    ProductDetail
  }
};
</script>

<style lang="scss">
.component.item-list {
  ul, ol {
    @include unlisted;
  }

  &.grid {
    @include grid-list;

    @include breakpoint(medium) {
      margin: 0 -8px;
    }

    ol li {
      margin-bottom: 25px;
    }
  }
  
  &.list li {
    border-bottom: 1px solid $colorPaleGray;
    padding: 20px 5px;
    @include breakpoint(medium) {
      padding: 25px 15px;
    }
    &:first-child {
      border-top: 1px solid $colorPaleGray;
    }
  }
}
</style>